import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import {
    CloseIcon,
    LabeledPageActionButton,
    PageActionButton,
    PauseIcon,
    PlayIcon,
    RelodeTheme,
} from "@relode/core";
import { JobStatus } from "@relode/core/domain";
import * as React from "react";

const styles = (theme: RelodeTheme) =>
    createStyles({
        pageActionButtonsContainer: {
            display: "flex",
        },
    });

interface Props extends WithStyles<typeof styles> {
    availableJobStatuses: JobStatus[];
    jobStatusAction: (status: JobStatus) => void;
}

export const JobActionsDesktop = withStyles(styles, {
    name: "JobActionsDesktop",
})((props: Props) => {
    const { classes, availableJobStatuses, jobStatusAction } = props;

    const actionIcon = (status: JobStatus, mobile: boolean) => {
        switch (status) {
            case JobStatus.Open: {
                return (
                    <PlayIcon
                        fontSize={mobile ? "small" : undefined}
                        color="primary"
                    />
                );
            }
            case JobStatus.Paused: {
                return (
                    <PauseIcon
                        fontSize={mobile ? "small" : undefined}
                        color="primary"
                    />
                );
            }
            case JobStatus.Closed: {
                return (
                    <CloseIcon
                        fontSize={mobile ? "small" : undefined}
                        color="primary"
                    />
                );
            }
        }
    };

    const hasActions =
        !!availableJobStatuses &&
        availableJobStatuses.length > 0 &&
        !!jobStatusAction;

    if (!hasActions) return null;

    return (
        <div className={classes.pageActionButtonsContainer}>
            {availableJobStatuses.map((status, i) => (
                <PageActionButton
                    key={i}
                    onClick={() => jobStatusAction(status)}
                    id={`${status.actionLabel}`}
                    color="primary"
                    title={`${status.actionLabel}`}
                    shadow
                >
                    {actionIcon(status, false)}
                </PageActionButton>
            ))}
        </div>
    );
});
